import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import Select from "react-select";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getAdminAgent,
  getAgentRetailer,
  getAllAgents,
  updateAgentRetailer,
} from "../../../services/agent.service";

export default function AgentRetailerUpdate() {
  const navigate = useNavigate();
  const [isLoading2, setIsLoading2] = useState(false);
  const { token } = useSelector((state) => state?.auth);
  const [agentRetailer, setAgentRetailer] = useState(null);
  const [agents, setAgents] = useState([]);
  const [selectedAgent, setSelectedAgent] = useState(null);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const retailerID = params.get("id");

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
  const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[Z]{1}[0-9A]{1}$/;

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
  } = useForm();

  const fetchAgentRetailer = async () => {
    try {
      const res = await getAgentRetailer(token, retailerID);
      if (res && res.status >= 200 && res.status < 300) {
        setAgentRetailer(res?.data);
      } else {
        Swal.fire(
          "Error",
          res?.data?.message || "Failed to fetch agent. Please try again.",
          "error"
        );
      }
    } catch (error) {
      Swal.fire(
        "Error",
        error?.response?.data?.error || "A network or server error occurred. Please try again later.",
        "error"
      );
    }
  };

  const fetchAgents = async (page = false) => {
    try {
      const params = { page };
      const res = await getAllAgents(token, params);
      if (res && res.status >= 200 && res.status < 300) {        
        setAgents(res?.data);
      } else {
        Swal.fire(
          "Error",
          res?.data?.message || "Failed to fetch agents. Please try again.",
          "error"
        );
      }
    } catch (error) {
      Swal.fire(
        "Error",
        error?.response?.data?.error || "A network or server error occurred. Please try again later.",
        "error"
      );
    }
  };

  useEffect(() => {
    fetchAgents();
    if (retailerID) {
      fetchAgentRetailer();
    }
  }, [retailerID]);

  useEffect(() => {
    if (agentRetailer) {
      setValue("agentName", agentRetailer?.added_by?.name);
      // const agent = agentRetailer?.added_by;
      // if (agent) {
      //   const agentOption = {
      //     value: agent.id,
      //     label: agent.fullname,
      //   };
      //   setSelectedAgent(agentOption);
      //   setValue("agentName", agentOption); // Set form value
      // }
      setValue("retailerName", agentRetailer?.owner_name);
      setValue("retailerEmail", agentRetailer?.email);
      setValue("shopName", agentRetailer?.shop_name);
      setValue("retailerPhone", agentRetailer?.mobile);
      setValue("retailerAddress", agentRetailer?.address);
      setValue("gstNumber", agentRetailer?.gst_number);
      setValue("panNumber", agentRetailer?.pan_number);
    }
  }, [agentRetailer]);

  const onSubmit = async (item) => {
    setIsLoading2(true);

    const data = {
      email: item.retailerEmail,
      mobile_number: item.retailerPhone,
      shop_name: item.shopName,
      PAN_number: item.panNumber,
      GST_number: item.gstNumber,
      owner_name: item.retailerName,
      address: item.retailerAddress,
      // added_by: selectedAgent
      role: "Retailer",
    };

    try {
      const res = await updateAgentRetailer(token, data, retailerID);

      if (res && res.status >= 200 && res.status < 300) {
        Swal.fire({
          title: "Updated!",
          text: `${item.agentName} Agent has been updated successfully.`,
          icon: "success",
          confirmButtonText: "OK",
        }).then(() => {
          navigate("/agent/agent-retailer");
        });
      } else if (res && res.status >= 400 && res.status < 500) {
        Swal.fire(
          "Error",
          res?.data?.message || "Invalid input. Please check your data.",
          "error"
        );
      } else {
        Swal.fire(
          "Error",
          res?.data?.error || "An unexpected error occurred. Please try again later.",
          "error"
        );
      }
    } catch (error) {
      Swal.fire(
        "Error",
        error?.response?.data?.error || "A network or server error occurred. Please try again later.",
        "error"
      );
    } finally {
      setIsLoading2(false);
    }
  };

  return (
    <div className="content-body">
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12 col-lg-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Update Retailer</h4>
                <Link to="/agent/agent-retailer">
                  <img
                    src="/assets/images/kidskart/icon/back-button.png"
                    alt="back"
                  />
                </Link>
              </div>
              <div className="card-body py-3">
                <div className="basic-form">
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="row">
                      {/* Agent Name */}
                      <div className="mb-4 col-md-6">
                        <div className="d-flex">
                          <label className="form-label">Agent Name</label>
                          <i class="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                        </div>
                        {/* <Select
                          options={agents.map(agent => ({
                            value: agent.customer_id,
                            label: agent.fullname,
                          }))}
                          {...register("agentName", { required: "Agent name is required" })}
                          onChange={selectedOption => {
                            setSelectedAgent(selectedOption); 
                            setValue("agentName", selectedOption);
                            clearErrors("agentName"); 
                          }}
                          value={selectedAgent}
                          placeholder="Select Agent"
                          isClearable
                        /> */}
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter agent name"
                          {...register("agentName", {
                            required: "Name is required",
                          })}
                          disabled
                          style={{
                            backgroundColor: "#f8f9fa",
                          }}
                        />
                        {errors.agentName && (
                          <p className="error">{errors.agentName.message}</p>
                        )}
                      </div>
                      {/* Retailer Name */}
                      <div className="mb-4 col-md-6">
                        <div className="d-flex">
                          <label className="form-label">Retailer Name</label>
                          <i class="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                        </div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter retailer name"
                          {...register("retailerName", {
                            required: "Name is required",
                          })}
                        />
                        {errors.retailerName && (
                          <p className="error">{errors.retailerName.message}</p>
                        )}
                      </div>
                      {/* Shop Name */}
                      <div className="mb-4 col-md-6">
                        <div className="d-flex">
                          <label className="form-label">Shop Name</label>
                          <i class="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                        </div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter shop name"
                          {...register("shopName", {
                            required: "Shop Name is required",
                          })}
                        />
                        {errors.shopName && (
                          <p className="error">{errors.shopName.message}</p>
                        )}
                      </div>

                      {/* Retailer Email */}
                      <div className="mb-4 col-md-6">
                        <div className="d-flex">
                          <label className="form-label">Retailer Email</label>
                          <i class="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                        </div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter retailer email"
                          {...register("retailerEmail", {
                            required: "Email is required",
                            pattern: {
                              value: emailRegex,
                              message: "Please enter a valid email",
                            },
                          })}
                        />
                        {errors.retailerEmail && (
                          <p className="error">
                            {errors.retailerEmail.message}
                          </p>
                        )}
                      </div>

                      {/* Retailer Phone */}
                      <div className="mb-4 col-md-6">
                        <div className="d-flex">
                          <label className="form-label">Contact Number</label>
                          <i class="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                        </div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Contact Number"
                          {...register("retailerPhone", {
                            required: "Phone is required",
                          })}
                        />
                        {errors.retailerPhone && (
                          <p className="error">
                            {errors.retailerPhone.message}
                          </p>
                        )}
                      </div>

                      {/* GST Number */}
                      <div className="mb-4 col-md-6">
                        <label className="form-label">GST Number</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter GST Number"
                          maxLength={30}
                          {...register("gstNumber", {
                            pattern: {
                              // value: gstRegex,
                              message: "Please enter a valid GST number",
                            },
                          })}
                        />
                        {errors.gstNumber && (
                          <p className="error">{errors.gstNumber.message}</p>
                        )}
                      </div>

                      {/* PAN Number */}
                      <div className="mb-4 col-md-6">
                        <label className="form-label">PAN Number</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter PAN Number"
                          maxLength={30}
                          {...register("panNumber", {
                            pattern: {
                              // value: panRegex,
                              message: "Please enter a valid PAN number",
                            },
                          })}
                        />
                        {errors.panNumber && (
                          <p className="error">{errors.panNumber.message}</p>
                        )}
                      </div>

                      {/* Retailer Address */}
                      <div className="mb-4 col-md-6">
                        <div className="d-flex">
                          <label className="form-label">Retailer Address</label>
                          <i class="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                        </div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter retailer address"
                          {...register("retailerAddress", {
                            required: "Address is required",
                          })}
                        />
                        {errors.retailerAddress && (
                          <p className="error">
                            {errors.retailerAddress.message}
                          </p>
                        )}
                      </div>
                    </div>

                    {!isLoading2 ? (
                      <div className="col-sm-4">
                        <button type="submit" className="btn btn-primary w-100">
                          UPDATE RETAILER
                        </button>
                      </div>
                    ) : (
                      <div className="col-sm-4">
                        <button
                          type="button"
                          className="btn btn-primary w-100"
                          disabled
                        >
                          UPDATING RETAILER
                        </button>
                        <div
                          className="spinner-border2 text-primary"
                          role="status"
                        >
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    )}
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
